<template>
  <div>
    </div>
</template>

<script>
export default {
  name: 'Security',
  data () {
    return {
      
    }
  },
  mounted() {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/platform/security/Security.vue